<div class="scroll-container" *ngIf="scrollTrackVisible === true">
    <div class="scroll-tracker" [ngStyle]="{'top.px' : itemScrollTrackTop, 'height.px' : itemScrollTrackHeight}"></div>
</div>